import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: []
}

export default (state = initialState, action) => {
	switch (action.type) {
        case actionTypes.REGISTER_BUSINESS_REQUEST:
            return {
                ...state,
                loading: true,
            }
		case actionTypes.REGISTER_BUSINESS_SUCCESS:
			return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.REGISTER_BUSINESS_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.REGISTER_BUSINESS_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.REGISTER_BUSINESS_RESET_ALL:
            return initialState
		default:
			return state;
	}
};
